import java from "../assets/img/java.webp";
import sb from "../assets/img/springboot.png";
import ss from "../assets/img/springsec.png";
import html from "../assets/img/html.png";
import js from "../assets/img/js.png";
import react from "../assets/img/react.png";
import python from "../assets/img/python.png";
import hb from "../assets/img/hibernate.png";
import sd from "../assets/img/springdata.webp";
import mdb from "../assets/img/mongo.png";
import msql from "../assets/img/mysql.png";
import sql from "../assets/img/sql.png";
import pgsql from "../assets/img/pgsql.png";
import bp from "../assets/img/bp.png";
import tl from "../assets/img/tl.png";
import wp from "../assets/img/wp.png";
import el from "../assets/img/el.png";
import docker from "../assets/img/docker.png";
import pm from "../assets/img/postman.png";
import git from "../assets/img/git.png";
import as from "../assets/img/as.png";
import vsc from "../assets/img/vsc.png";
import ec from "../assets/img/eclipse.png";
import nb from "../assets/img/nb.png";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
import colorSharp from "../assets/img/color-sharp.png";

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <h2>Superpowers</h2>
              <br />
              <h4>Languages</h4>
              <br />
              <Carousel
                responsive={responsive}
                infinite={false}
                className="owl-carousel owl-theme skill-slider"
              >
                <div className="item">
                  <img src={java} alt="Image" />
                  <h5>Core Java</h5>
                </div>
                <div className="item">
                  <img src={html} alt="Image" />
                  <h5>HTML & CSS</h5>
                </div>
                <div className="item">
                  <img src={js} alt="Image" />
                  <h5>JavaScript</h5>
                </div>
                <div className="item">
                  <img src={sql} alt="Image" />
                  <h5>SQL</h5>
                </div>
                <div className="item">
                  <img src={python} alt="Image" />
                  <h5>Python</h5>
                </div>
              </Carousel>
              <br />
              <center>
                <hr />
              </center>
              <br />
              <h4>Databases</h4>
              <br />
              <Carousel
                responsive={responsive}
                infinite={false}
                className="owl-carousel owl-theme skill-slider"
              >
                <div className="item">
                  <img src={msql} alt="Image" />
                  <h5>MySQL</h5>
                </div>
                <div className="item">
                  <img src={mdb} alt="Image" />
                  <h5>MongoDB</h5>
                </div>
                <div className="item">
                  <img src={pgsql} alt="Image" />
                  <h5>PostgreSQL</h5>
                </div>
              </Carousel>
              <br />
              <center>
                <hr />
              </center>
              <br />
              <h4>ORM, Frameworks, Platforms & Libraries</h4>
              <br />
              <Carousel
                responsive={responsive}
                infinite={false}
                className="owl-carousel owl-theme skill-slider"
              >
                <div className="item">
                  <img src={sb} alt="Image" />
                  <h5>Spring Boot</h5>
                </div>
                <div className="item">
                  <img src={ss} alt="Image" />
                  <h5>Spring Security</h5>
                </div>
                <div className="item">
                  <img src={react} alt="Image" />
                  <h5>React</h5>
                </div>
                <div className="item">
                  <img src={sd} alt="Image" />
                  <h5>Spring Data JPA</h5>
                </div>
                <div className="item">
                  <img src={hb} alt="Image" />
                  <h5>Hibernate</h5>
                </div>
                <div className="item">
                  <img src={el} alt="Image" />
                  <h5>EclipseLink</h5>
                </div>
                <div className="item">
                  <img src={bp} alt="Image" />
                  <h5>Bootstrap</h5>
                </div>
                <div className="item">
                  <img src={tl} alt="Image" />
                  <h5>Thymeleaf</h5>
                </div>
                <div className="item">
                  <img src={wp} alt="Image" />
                  <h5>Wordpress</h5>
                </div>
              </Carousel>
              <br />
              <center>
                <hr />
              </center>
              <br />
              <h4>Tools</h4>
              <br />
              <Carousel
                responsive={responsive}
                infinite={false}
                className="owl-carousel owl-theme skill-slider"
              >
                <div className="item">
                  <img src={docker} alt="Image" />
                  <h5>Docker</h5>
                </div>
                <div className="item">
                  <img src={pm} alt="Image" />
                  <h5>Postman</h5>
                </div>
                <div className="item">
                  <img src={git} alt="Image" />
                  <h5>GIT</h5>
                </div>
                <div className="item">
                  <img src={as} alt="Image" />
                  <h5>Android Studio</h5>
                </div>
                <div className="item">
                  <img src={vsc} alt="Image" />
                  <h5>Visual Studio Code</h5>
                </div>
                <div className="item">
                  <img src={ec} alt="Image" />
                  <h5>Eclipse IDE</h5>
                </div>
                <div className="item">
                  <img src={nb} alt="Image" />
                  <h5>Netbeans IDE</h5>
                </div>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  );
};
